import React from 'react';

import {BulkActionResult} from 'src/components/bulk-tool';

import {UpdateUserDeviceRegistrationResultModal} from './update-device-registration.result.modal';
import {
    clearResult,
    selectUpdateDeviceRegistrationShown,
    selectUpdateDeviceRegistrationTask,
    selectUpdateDeviceRegistrationUuid,
} from './update-device-registration.slice';


export const UpdateDeviceRegistrationResult = () => (
    <BulkActionResult
        actionIdSelector={selectUpdateDeviceRegistrationUuid}
        actionTaskSelector={selectUpdateDeviceRegistrationTask}
        actionShownSelector={selectUpdateDeviceRegistrationShown}
        clearResult={clearResult}>
        {({id, onClose}) => <UpdateUserDeviceRegistrationResultModal id={id} onClose={onClose}/>}
    </BulkActionResult>
);
